<template>
    <new-modal
        size="xl"
        :title="'Archive' + ' ' + classroom.name + ' ?'"
        ref="archive_classroom_modal"
    >
        <template #trigger>
            <span class="link block p-4 !text-red-500 hover:text-red-700">
                Archive Classroom
            </span>
        </template>
        <template #content>
            <div class="flex flex-col gap-4">
                <div class="mb-8 flex flex-col gap-4">
                    <p>
                        Do you want to archive your classroom
                        <span class="italic">{{ classroom.name }}</span> Please
                        note, archived classrooms will become
                        <span class="font-bold">“read-only”</span>. The data
                        will still be visible, but you won’t be able to make any
                        changes.
                    </p>
                    <p>
                        Archived classrooms
                        <span class="font-bold">cannot be unarchived</span>.
                    </p>
                </div>
                <div class="flex justify-end">
                    <div class="btn btn-transparent" @click="cancel">
                        Cancel
                    </div>
                    <div class="btn btn-danger" @click="archiveClassroom">
                        Archive Classroom
                    </div>
                </div>
            </div>
        </template>
    </new-modal>
</template>
<script>
import NewModal from "@/Components/NewModal";

export default {
    name: "GroupArchiveClassroomModal",
    emits: ["close-modal"],
    components: {
        NewModal,
    },
    props: {
        classroom: {
            type: Object,
            default: {},
        },
    },
    methods: {
        archiveClassroom() {
            this.$inertia.get(
                route("group.classroom.archive", {
                    classroom: this.classroom.id,
                })
            );
        },
        cancel() {
            this.$refs.archive_classroom_modal.closeModal();
        },
    },
};
</script>
